// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Scoped styles for the seller reviews React surface. Everything is nested under
 * \`.seller-reviews\` so nothing leaks from (or picks up) the dashboard's global
 * \`div.page section\` / \`article\` / \`aside\` descendant selectors.
 */
.seller-reviews {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.seller-reviews__metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.seller-reviews__public-link {
  margin: 0.75rem 0 0;
}

.seller-reviews__metric {
  flex: 1 1 8rem;
  padding: 1rem;
  border: 1px solid var(--color-border-soft, #ddd);
  border-radius: 0.5rem;
  background: var(--color-surface, #fff);
  color: var(--color-text, inherit);
}

.seller-reviews__metric-value {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.1;
}

.seller-reviews__metric-label {
  font-size: 0.85rem;
  color: var(--color-text-muted, #666);
}

.seller-reviews__tabs {
  display: flex;
  gap: 0.5rem;
  border-bottom: 1px solid var(--color-border-soft, #ddd);
}

.seller-reviews__tab {
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
  color: var(--color-text-muted, #666);
  border-bottom: 2px solid transparent;
}

.seller-reviews__tab.is-active {
  color: inherit;
  font-weight: 600;
  border-bottom-color: currentColor;
}

.seller-reviews__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 0.75rem;
}

.seller-reviews__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.seller-reviews__chip {
  padding: 0.3rem 0.75rem;
  border: 1px solid var(--color-border-soft, #ddd);
  border-radius: 999px;
  background: none;
  cursor: pointer;
  font: inherit;
  font-size: 0.85rem;
}

.seller-reviews__chip.is-active {
  background: var(--color-accent, #316C29);
  border-color: var(--color-accent, #316C29);
  color: #fff;
}

.seller-reviews__search {
  flex: 1 1 12rem;
  padding: 0.35rem 0.6rem;
  border: 1px solid var(--color-border-soft, #ddd);
  border-radius: 0.35rem;
  font: inherit;
}

.seller-reviews__table {
  width: 100%;
  border-collapse: collapse;
}

.seller-reviews__table th,
.seller-reviews__table td {
  padding: 0.6rem 0.5rem;
  border-bottom: 1px solid var(--color-border-soft, #eee);
  text-align: left;
  vertical-align: top;
}

.seller-reviews__table button {
  padding: 0.3rem 0.75rem;
  font: inherit;
  font-size: 0.85rem;
  line-height: 1.2;
}

.seller-reviews__row {
  cursor: pointer;
}

.seller-reviews__row:hover {
  background: var(--color-hover-bg, #f6f8fa);
}

.seller-reviews__badge {
  display: inline-block;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
}

.seller-reviews__badge--positive {
  background: #e5f5e9;
  color: #1a7f37;
}

.seller-reviews__badge--negative {
  background: #fbe9e7;
  color: #c0392b;
}

.seller-reviews__badge--neutral {
  background: #eef1f4;
  color: #555;
}

.seller-reviews__snippet {
  color: var(--color-text-muted, #555);
  font-size: 0.9rem;
}

.seller-reviews__reply-indicator {
  font-size: 0.8rem;
  font-weight: 600;
}

.seller-reviews__reply-indicator--replied {
  color: #1a7f37;
}

.seller-reviews__reply-indicator--pending {
  color: #b26a00;
}

.seller-reviews__empty,
.seller-reviews__loading {
  padding: 1.5rem;
  text-align: center;
  color: var(--color-text-muted, #666);
}

.seller-reviews__skeleton {
  height: 1rem;
  margin: 0.5rem 0;
  border-radius: 0.25rem;
  background: linear-gradient(90deg, #eee, #f5f5f5, #eee);
}

.seller-reviews__detail-section {
  margin-bottom: 1rem;
}

.seller-reviews__detail-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-text-muted, #888);
}

.seller-reviews__response-form textarea {
  width: 100%;
  min-height: 6rem;
  padding: 0.5rem;
  border: 1px solid var(--color-border-soft, #ddd);
  border-radius: 0.35rem;
  font: inherit;
}

.seller-reviews__char-count {
  font-size: 0.8rem;
  color: var(--color-text-muted, #888);
  text-align: right;
}

.seller-reviews__response-form form button + button {
  margin-left: 0.5rem;
}

.seller-reviews__pagination {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-top: 0.75rem;
}

/*
 * Dark mode. The rules above use \`--color-*\` tokens (public/css/tokens.css), so
 * surfaces, borders, and muted text follow the theme for free. Only the pieces
 * with hardcoded literals — the sentiment badges, the loading skeleton, the
 * reply indicators, and the native form controls — need an explicit override.
 */
[data-theme="dark"] .seller-reviews__badge--positive {
  background: #16301f;
  color: #8fd6a0;
}

[data-theme="dark"] .seller-reviews__badge--negative {
  background: #3b1418;
  color: #f1a8ae;
}

[data-theme="dark"] .seller-reviews__badge--neutral {
  background: #222f28;
  color: #9fb0a6;
}

[data-theme="dark"] .seller-reviews__reply-indicator--replied {
  color: #8fd6a0;
}

[data-theme="dark"] .seller-reviews__reply-indicator--pending {
  color: #e8c26a;
}

[data-theme="dark"] .seller-reviews__skeleton {
  background: linear-gradient(90deg, #1c2620, #263a30, #1c2620);
}

[data-theme="dark"] .seller-reviews__search,
[data-theme="dark"] .seller-reviews__response-form textarea {
  background: var(--color-surface, #1c2620);
  color: var(--color-text, #e3ece6);
}

[data-theme="dark"] .seller-reviews__chip {
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Reviews/SellerReviews.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gDAAgD;EAChD,qBAAqB;EACrB,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gDAAgD;EAChD,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;EAKE;AACF;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;EAEE,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/*\n * Scoped styles for the seller reviews React surface. Everything is nested under\n * `.seller-reviews` so nothing leaks from (or picks up) the dashboard's global\n * `div.page section` / `article` / `aside` descendant selectors.\n */\n.seller-reviews {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.seller-reviews__metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.seller-reviews__public-link {\n  margin: 0.75rem 0 0;\n}\n\n.seller-reviews__metric {\n  flex: 1 1 8rem;\n  padding: 1rem;\n  border: 1px solid var(--color-border-soft, #ddd);\n  border-radius: 0.5rem;\n  background: var(--color-surface, #fff);\n  color: var(--color-text, inherit);\n}\n\n.seller-reviews__metric-value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  line-height: 1.1;\n}\n\n.seller-reviews__metric-label {\n  font-size: 0.85rem;\n  color: var(--color-text-muted, #666);\n}\n\n.seller-reviews__tabs {\n  display: flex;\n  gap: 0.5rem;\n  border-bottom: 1px solid var(--color-border-soft, #ddd);\n}\n\n.seller-reviews__tab {\n  padding: 0.5rem 1rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font: inherit;\n  color: var(--color-text-muted, #666);\n  border-bottom: 2px solid transparent;\n}\n\n.seller-reviews__tab.is-active {\n  color: inherit;\n  font-weight: 600;\n  border-bottom-color: currentColor;\n}\n\n.seller-reviews__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.seller-reviews__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.seller-reviews__chip {\n  padding: 0.3rem 0.75rem;\n  border: 1px solid var(--color-border-soft, #ddd);\n  border-radius: 999px;\n  background: none;\n  cursor: pointer;\n  font: inherit;\n  font-size: 0.85rem;\n}\n\n.seller-reviews__chip.is-active {\n  background: var(--color-accent, #316C29);\n  border-color: var(--color-accent, #316C29);\n  color: #fff;\n}\n\n.seller-reviews__search {\n  flex: 1 1 12rem;\n  padding: 0.35rem 0.6rem;\n  border: 1px solid var(--color-border-soft, #ddd);\n  border-radius: 0.35rem;\n  font: inherit;\n}\n\n.seller-reviews__table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.seller-reviews__table th,\n.seller-reviews__table td {\n  padding: 0.6rem 0.5rem;\n  border-bottom: 1px solid var(--color-border-soft, #eee);\n  text-align: left;\n  vertical-align: top;\n}\n\n.seller-reviews__table button {\n  padding: 0.3rem 0.75rem;\n  font: inherit;\n  font-size: 0.85rem;\n  line-height: 1.2;\n}\n\n.seller-reviews__row {\n  cursor: pointer;\n}\n\n.seller-reviews__row:hover {\n  background: var(--color-hover-bg, #f6f8fa);\n}\n\n.seller-reviews__badge {\n  display: inline-block;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.seller-reviews__badge--positive {\n  background: #e5f5e9;\n  color: #1a7f37;\n}\n\n.seller-reviews__badge--negative {\n  background: #fbe9e7;\n  color: #c0392b;\n}\n\n.seller-reviews__badge--neutral {\n  background: #eef1f4;\n  color: #555;\n}\n\n.seller-reviews__snippet {\n  color: var(--color-text-muted, #555);\n  font-size: 0.9rem;\n}\n\n.seller-reviews__reply-indicator {\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.seller-reviews__reply-indicator--replied {\n  color: #1a7f37;\n}\n\n.seller-reviews__reply-indicator--pending {\n  color: #b26a00;\n}\n\n.seller-reviews__empty,\n.seller-reviews__loading {\n  padding: 1.5rem;\n  text-align: center;\n  color: var(--color-text-muted, #666);\n}\n\n.seller-reviews__skeleton {\n  height: 1rem;\n  margin: 0.5rem 0;\n  border-radius: 0.25rem;\n  background: linear-gradient(90deg, #eee, #f5f5f5, #eee);\n}\n\n.seller-reviews__detail-section {\n  margin-bottom: 1rem;\n}\n\n.seller-reviews__detail-label {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--color-text-muted, #888);\n}\n\n.seller-reviews__response-form textarea {\n  width: 100%;\n  min-height: 6rem;\n  padding: 0.5rem;\n  border: 1px solid var(--color-border-soft, #ddd);\n  border-radius: 0.35rem;\n  font: inherit;\n}\n\n.seller-reviews__char-count {\n  font-size: 0.8rem;\n  color: var(--color-text-muted, #888);\n  text-align: right;\n}\n\n.seller-reviews__response-form form button + button {\n  margin-left: 0.5rem;\n}\n\n.seller-reviews__pagination {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  margin-top: 0.75rem;\n}\n\n/*\n * Dark mode. The rules above use `--color-*` tokens (public/css/tokens.css), so\n * surfaces, borders, and muted text follow the theme for free. Only the pieces\n * with hardcoded literals — the sentiment badges, the loading skeleton, the\n * reply indicators, and the native form controls — need an explicit override.\n */\n[data-theme=\"dark\"] .seller-reviews__badge--positive {\n  background: #16301f;\n  color: #8fd6a0;\n}\n\n[data-theme=\"dark\"] .seller-reviews__badge--negative {\n  background: #3b1418;\n  color: #f1a8ae;\n}\n\n[data-theme=\"dark\"] .seller-reviews__badge--neutral {\n  background: #222f28;\n  color: #9fb0a6;\n}\n\n[data-theme=\"dark\"] .seller-reviews__reply-indicator--replied {\n  color: #8fd6a0;\n}\n\n[data-theme=\"dark\"] .seller-reviews__reply-indicator--pending {\n  color: #e8c26a;\n}\n\n[data-theme=\"dark\"] .seller-reviews__skeleton {\n  background: linear-gradient(90deg, #1c2620, #263a30, #1c2620);\n}\n\n[data-theme=\"dark\"] .seller-reviews__search,\n[data-theme=\"dark\"] .seller-reviews__response-form textarea {\n  background: var(--color-surface, #1c2620);\n  color: var(--color-text, #e3ece6);\n}\n\n[data-theme=\"dark\"] .seller-reviews__chip {\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
